<template>
    <section id="menu" class="bg-light w-100">
        <h2 class="text-center mb-4">OUR PRODUCTS</h2>
        <div class="d-flex img-container">

            <div class="col card h-100">
              <img src="../../assets/img/food-1.webp" class="card-img-top" alt="Dish">
           
            </div>

              <div class="card card-dark col h-100">
              <img src="../../assets/img/food-2.webp" class="darker card-img-top" alt="Dish">
              
              <div class="center-card">
             <h2>Featured Products</h2>
<p class=" mx-4 text-center">Here's a sample of some of the products we do.</p>

              </div>
            </div>

              <div class="col card h-100">
              <img src="../../assets/img/food-3.webp" class="card-img-top" alt="Dish">
            </div>

            
        </div>
          <div class="d-flex img-container">

            <div class="col card h-100">
              <img src="../../assets/img/food-4.webp" class="card-img-top" alt="Dish">
           
            </div>
  <div class="col card card-dark h-100">
              <img src="../../assets/img/food-5.webp" class="card-img-top" alt="Dish">
           
            </div>
            

              <div class="col card h-100">
              <img src="../../assets/img/food-6.webp" class="card-img-top" alt="Dish">
            </div>

            
        </div>
    </section>
</template>

<script>
export default {
  name: 'SpecialDishes'
}
</script>

<style scoped>
.card {
    position: relative;
}
.center-card {
    top:0;
    left:0;
    bottom: 0;
    right: 0;
    position:absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color:white;
}

img {
    object-fit: cover;
    width:100%;
    height:100%;
}

img.darker {
    filter: brightness(0.3);
}

.img-container {
    height:400px;
}

@media (max-width:768px) {
    .img-container {
    height:200px;
}

.card-dark {
    display: none;
}
}



</style>
